/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

:host {
  position: relative;
  display: flex;
  flex-grow: 1;
  align-items: center;
  outline-color: transparent;
}

.container {
  position: relative;
  display: flex;
  flex-grow: 1;
  cursor: pointer;
  align-items: center;
  color: var(--calcite-color-text-3);
  text-decoration-line: none;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  text-align: start;
}
.container a {
  position: relative;
  display: flex;
  flex-grow: 1;
  cursor: pointer;
  align-items: center;
  color: var(--calcite-color-text-3);
  text-decoration-line: none;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  outline-color: transparent;
}

.dropdown-item-content {
  flex: 1 1 auto;
  padding-block: 0.125rem;
}

.dropdown-item-icon {
  position: relative;
  opacity: 0;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transform: scale(0.9);
}

:host([scale=s]) .container {
  padding-block: 0.25rem;
  padding-inline: 0.5rem;
  font-size: var(--calcite-font-size--2);
  line-height: 1rem;
}
:host([scale=s]) .dropdown-item-icon,
:host([scale=s]) .dropdown-item-icon--start {
  padding-inline-end: var(--calcite-spacing-sm);
}
:host([scale=s]) .dropdown-item-icon--end {
  padding-inline-start: var(--calcite-spacing-sm);
}

:host([scale=m]) .container {
  padding-block: 0.5rem;
  padding-inline: 0.75rem;
  font-size: var(--calcite-font-size--1);
  line-height: 1rem;
}
:host([scale=m]) .dropdown-item-icon,
:host([scale=m]) .dropdown-item-icon--start {
  padding-inline-end: var(--calcite-spacing-md);
}
:host([scale=m]) .dropdown-item-icon--end {
  padding-inline-start: var(--calcite-spacing-md);
}

:host([scale=l]) .container {
  padding-block: 0.625rem;
  padding-inline: 1rem;
  font-size: var(--calcite-font-size-0);
  line-height: 1.25rem;
}
:host([scale=l]) .dropdown-item-icon,
:host([scale=l]) .dropdown-item-icon--start {
  padding-inline-end: var(--calcite-spacing-xl);
}
:host([scale=l]) .dropdown-item-icon--end {
  padding-inline-start: var(--calcite-spacing-xl);
}

:host(:focus) {
  outline: 2px solid transparent;
  outline-offset: 2px;
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}
:host(:focus) .container {
  color: var(--calcite-color-text-1);
  text-decoration-line: none;
}

:host(:hover:not([disabled])) .container,
:host(:active:not([disabled])) .container {
  background-color: var(--calcite-color-foreground-2);
  color: var(--calcite-color-text-1);
  text-decoration-line: none;
}
:host(:hover:not([disabled])) .dropdown-link,
:host(:active:not([disabled])) .dropdown-link {
  color: var(--calcite-color-text-1);
}

:host(:active:not([disabled])) .container {
  background-color: var(--calcite-color-foreground-3);
}

:host([selected]) .container:not(.container--none-selection),
:host([selected]) .dropdown-link {
  font-weight: var(--calcite-font-weight-medium);
  color: var(--calcite-color-text-1);
}
:host([selected]) .container:not(.container--none-selection) calcite-icon,
:host([selected]) .dropdown-link calcite-icon {
  color: var(--calcite-color-brand);
}

:host(:hover:not([disabled])) .dropdown-item-icon {
  color: var(--calcite-color-border-1);
  opacity: 1;
}

:host([selected]) .dropdown-item-icon {
  color: var(--calcite-color-brand);
  opacity: 1;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}

:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}